import { TypeCompatibility } from '@/api/types/backend-dto-types';

/**
 * UI helper functions for displaying validation status
 * These are frontend-specific and handle visual presentation only
 */

/**
 * Get validation icon class based on compatibility status
 */
export function getValidationIconClass(compatibility: TypeCompatibility): string {
  switch (compatibility) {
    case TypeCompatibility.Valid:
      return 'lucide--check-circle text-green-600';
    case TypeCompatibility.Info:
      return 'lucide--info text-blue-600';
    case TypeCompatibility.Warning:
      return 'lucide--alert-triangle text-yellow-600';
    case TypeCompatibility.Error:
      return 'lucide--x-circle text-red-600';
  }
}

/**
 * Get validation border class based on compatibility status
 */
export function getValidationBorderClass(compatibility: TypeCompatibility): string {
  switch (compatibility) {
    case TypeCompatibility.Valid:
      return '';
    case TypeCompatibility.Info:
      return 'border-blue-300';
    case TypeCompatibility.Warning:
      return 'border-yellow-300';
    case TypeCompatibility.Error:
      return 'border-red-300';
  }
}

/**
 * Get validation text class based on compatibility status
 */
export function getValidationTextClass(compatibility: TypeCompatibility): string {
  switch (compatibility) {
    case TypeCompatibility.Valid:
      return 'text-green-700';
    case TypeCompatibility.Info:
      return 'text-blue-700';
    case TypeCompatibility.Warning:
      return 'text-yellow-700';
    case TypeCompatibility.Error:
      return 'text-red-700';
  }
}

/**
 * Get validation background class based on compatibility status
 */
export function getValidationBackgroundClass(compatibility: TypeCompatibility): string {
  switch (compatibility) {
    case TypeCompatibility.Valid:
      return '';
    case TypeCompatibility.Info:
      return 'bg-blue-50';
    case TypeCompatibility.Warning:
      return 'bg-yellow-50';
    case TypeCompatibility.Error:
      return 'bg-red-50';
  }
}
